import "./RecreationalCamp.scss";
import { Card, MenuItem, Select, Tooltip } from "@mui/material";
import { Field, Formik } from "formik";
import * as yup from "yup";
import {
  API_RESPONSE,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  PROFESSIONAL_DETAILS,
  ROUTES,
  STORAGE_KEYS,
  TEACHING_MODE,
  TOASTER_CONFIGS,
  VALIDATION_CONSTANT,
} from "../../../../../Utilities/Constants/Constants";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  REGISTRATION_ERRORS,
} from "../../../../../Utilities/Constants/Validations";
import API_END_POINTS from "../../../../../Utilities/Constants/ApiEndpoints";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../../../Services/Interceptor/Interceptor";
import { GetSessionStorageData, numberOnly } from "../../../../../Services/Helpers/Helper";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import { useLocation } from "react-router-dom";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CategoryValidationDialog from "../../../../../Shared/CategoryValidationDialog/CategoryValidationDialog";

const ReacreationalCamp = (props: any) => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [selectedSubjects, setSelectedSubjects]: any = useState(" ");
  const [selectedSubjectsList, setSelectedSubjectsList]: any = useState(" ");
  const [modeOfTeching, setModeOfTeaching] = useState(NUMBER_CONSTANTS.TWO);
  const [subjectList, setSubjectList]: any = useState([]);
  const [subjectListCopy, setSubjectListCopy]: any = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(API_RESPONSE.FALSE);
  const [experience, setExperience] = useState("");
  const [experienceErrText, setExperienceErrText] = useState(false);
  const [personalDetail, setPersonalDetail]: any = useState({});
  const [userType, setuserType]: any = useState("");
  const [initialValues, setInitialValues] = useState({ });
  const [categoryValidationDetails, setCategoryValidationDetails] = useState<any>("")
  const [categoryValidationMessage, setCategoryValidationMessage] = useState<any>("")
  const [open, setOpen] = useState<boolean>(false)
  const location = useLocation();

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));
  }, []);

  useEffect(() => {
    getCategoriesList(API_END_POINTS.GET_RECREATIONAL);
    getRegistrationDetail(API_END_POINTS.GET_CAMP_DETAILS);
  }, [userType]);

  useEffect(() => {
    if (personalDetail) setDetails();
  }, [personalDetail]);

  const setDetails = () => {
    setSelectedSubjects(personalDetail?.activities_and_experience);
    setExpSubject(personalDetail?.activities_and_experience ? personalDetail?.activities_and_experience : []);
    setInitialValues({
      [PROFESSIONAL_DETAILS.ACTIVITIES_OFFERED]:
        personalDetail?.activities_and_experience,
      [PROFESSIONAL_DETAILS.TEACHING_MODE]: `${NUMBER_CONSTANTS.TWO}`,
      [PROFESSIONAL_DETAILS.EXPERIENCE]: personalDetail?.years_of_camp
        ? personalDetail?.years_of_camp
        : "",
    });
  };

  const getRegistrationDetail = (API_END_POINT: any) => {
    axiosInstance.get(API_END_POINT).then((response) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setPersonalDetail(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
      }
    });
  };

  const getCategoriesList = (API_POINT: any) => {
    axiosInstance.get(API_POINT).then((response: any) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setSubjectList(response.data.result.data);
        setSubjectListCopy(response.data.result.data);
      }
    });
  };

  /*geting seteled category detailes */
  const getValidateCategoryDetailes = () => {
    axiosInstance.get(API_END_POINTS.MANAGE_CATEGORY)
    .then((res:any)=>{
      if(res.data[API_RESPONSE.STATUS]) {
        setCategoryValidationDetails(res.data.result.data)
        setOpen(true)
      }
    })
  }

  /*Category validation */
  const validateCategory = () => {
    let payload = {
      "category_id": +selectedSubjects.id || null
    }
    axiosInstance.post(API_END_POINTS.MANAGE_CATEGORY, payload)
    .then(
      (res:any) => {
        if(!res.data.result.data.status) {
          getValidateCategoryDetailes()
          setCategoryValidationMessage(res.data.message)
        } else {
          onAddSubjects()
        }
      }
    ).catch(()=>{
    })
  } 
  
  /*undate or accept commision change */
  const putValidationCategory = () => {
    let payload = {
      "id":categoryValidationDetails?.id, 
      "category_id": categoryValidationDetails?.category_id ,
      "teach_service_provider_id": categoryValidationDetails?.teach_service_provider,
      "status":"accepted"
    }
    axiosInstance.put(API_END_POINTS.MANAGE_CATEGORY, payload)
    .then((res:any)=>{
      if(res.data[API_RESPONSE.STATUS]) {
        onAddSubjects()
        handleClose()
      }
    })
  }

  const personalValidationSchema = yup.object({});

  /* Update subject state */
  const onSelectSubjects = (event: any) => {
    setSelectedSubjectsList(event.target.value);
    event.target.value.id ?
      setSelectedSubjects(event.target.value) :
      setSelectedSubjects(" ");
  };

  const onChangeExperience = (event: any) => {
    if (event.target.value <= 100 && selectedSubjectsList?.min_experience) {
      setExperience(event.target.value);
      if (event.target.value >= selectedSubjectsList?.min_experience) {
        setExperienceErrText(false)
      } else {
        setExperienceErrText(true)
      }
    }
  };
  const [expSubject, setExpSubject]: any = useState([]);
  const [expectedFee, setExpectedFee] = useState("");
  const [subjectFormSubmitted, setSubjectFormSubmitted] = useState(
    API_RESPONSE.FALSE
  );
  useEffect(() => { }, [subjectList]);

  useEffect(() => {
    let keyArr: any = [];
    expSubject?.forEach((obj: any) => {
      keyArr.push(obj?.id);
    });
    userType === `${NUMBER_CONSTANTS.FOUR}`
      ? setSubjectList(
        subjectListCopy.filter(
          (item: any, index: any) => !keyArr.includes(item?.id)
        )
      )
      : setSubjectList(
        subjectListCopy.filter(
          (item: any, index: any) => !keyArr.includes(item?.id)
        )
      );
    setExperience("");
    setExpectedFee("");
    setSelectedSubjects(" ");
  }, [expSubject, subjectListCopy]);

  const onAddSubjects = () => {
    setSubjectFormSubmitted(API_RESPONSE.TRUE);
    if (selectedSubjects && /* experience !== "" && */ expectedFee != "" && selectedSubjects?.id && !experienceErrText) {
      setExpSubject([
        ...expSubject,
        {
          id: selectedSubjects?.id,
          activity: selectedSubjects?.category_name,
          experience: experience,
          arabic_name: selectedSubjects?.arabic_category_name,
          expected_fee: expectedFee,
          course_mode: TEACHING_MODE.OFFLINE,
        },
      ]);
      setSubjectFormSubmitted(API_RESPONSE.FALSE);
    }
  };

  /* Deleting subjects from list */
  const handleDeleteSubject = (index: any) => {
    setExpSubject(
      expSubject?.filter((course: any, i: any) => course.id !== index)
    );
  };

  const onEditInput = (index: any, fee: any) => {
    let payload = expSubject;
    payload[index].expected_fee = fee;
    setExpSubject([...payload]);
  };
  const onEditSubject = (index: any) => {
    let payload = expSubject;
    payload[index].isEdit = payload[index].isEdit
      ? payload[index].isEdit === API_RESPONSE.TRUE
        ? API_RESPONSE.FALSE
        : API_RESPONSE.TRUE
      : (payload[index].isEdit = API_RESPONSE.TRUE);
    setExpSubject([...payload]);
  };

  /* Submit API call */
  const onSubmitData = (payload: any) => {
    payload.activities_and_experience = expSubject;
    if (expSubject?.length > 0) {
      let END_POINT = location.pathname === ROUTES.PROFILE ? API_END_POINTS.CAMP_PROFILE_UPDATE : API_END_POINTS.CAMP_PROFESSIONAL_REGISTER;
      axiosInstance
        .put(
          END_POINT +
          `?${VALIDATION_CONSTANT.PAGE}=` +
          NUMBER_CONSTANTS.TWO,
          payload
        )
        .then((response: any) => {
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            toast.success(response.data.message, TOASTER_CONFIGS);
            if (location.pathname !== ROUTES.PROFILE)
              onNavigate(NUMBER_CONSTANTS.THREE);
          }
        });
    } else {
      toast.error(REGISTRATION_ERRORS.ADD_ACTIVITY);
    }
  };

  /* Navigate call */
  const onNavigate = (state: any) => {
    props.setActiveStatus(state);
  };

  return (
    <div className="row details-wrapper">
      <div className="col-md-12">
        <Card className="pd-card-wrapper">
          <Formik
            initialValues={initialValues}
            validationSchema={personalValidationSchema}
            enableReinitialize={true}
            onSubmit={(values, actions) => {
              onSubmitData(values);
            }}
          >
            {(formik: any) => {
              return (
                <div>
                  <div className="activity-wrapper">
                    <div className="row row-wrap">
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label">
                            {t("Activities Offered")}
                          </label>
                          <Select
                            name={PROFESSIONAL_DETAILS.ACTIVITIES_OFFERED}
                            value={selectedSubjects}
                            className="filter-select"
                            onChange={(e: any) => {
                              onSelectSubjects(e);
                              formik.setFieldValue(
                                PROFESSIONAL_DETAILS.ACTIVITIES_OFFERED,
                                [e.target.value]
                              );
                            }}
                          >
                            <MenuItem value={" "}>Please select activities offered</MenuItem>
                            {subjectList?.map((sub: any, index: any) => {
                              return (
                                <MenuItem value={sub}>
                                  {userType === `${NUMBER_CONSTANTS.FOUR}`
                                    ? sub.course_category_name
                                    : sub.category_name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <div className="errorMessage">
                            {subjectFormSubmitted &&
                              !selectedSubjects?.id && (
                                <p>{t(`Please select activities offered`)}</p>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label">
                            {t("Mode of Teaching")}
                          </label>
                          <Select
                            // multiple
                            name={PROFESSIONAL_DETAILS.TEACHING_MODE}
                            value={modeOfTeching}
                            disabled
                            className="filter-select email-input teaching-mode"
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                PROFESSIONAL_DETAILS.TEACHING_MODE,
                                e.target.value
                              );
                              setModeOfTeaching(e.target.value);
                            }}
                          >
                            <MenuItem value="2">On-Premises</MenuItem>
                          </Select>
                          {formSubmitted && !modeOfTeching && (
                            <div className="errorMessage">
                              <p>Please select mode of teaching</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row row-wrap">
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label">
                            {t("Years of Experience")}
                          </label>
                          <Field
                            name={PROFESSIONAL_DETAILS.EXPERIENCE}
                            className="email-input"
                            placeholder={t("Years of Experience")}
                            value={experience}
                            onChange={(e: any) => {
                              onChangeExperience(e);
                              formik.setFieldValue(
                                PROFESSIONAL_DETAILS.EXPERIENCE,
                                e.target.value
                              );
                            }}
                          />
                        </div>
                        {experienceErrText && selectedSubjectsList && <div className="errorMessage">
                          <p>Please Enter Min expeience {selectedSubjectsList?.min_experience}</p>
                        </div>}
                        {/* <div className="errorMessage">
                          {subjectFormSubmitted && experience == "" && (
                            <p>{t(`Please enter the expereince`)}</p>
                          )}
                        </div> */}
                      </div>
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label">
                            {t("Expected Fee(AED)")}
                          </label>
                          <Field
                            name={"Expected fee"}
                            className="email-input"
                            value={expectedFee}
                            maxlength={6}
                            onInput={numberOnly}
                            onPaste={numberOnly}
                            placeholder={t("Expected Fee (AED)")}
                            onChange={(e: any) => {
                              if (e.target.value <= parseInt(selectedSubjectsList?.max_price)) {
                                setExpectedFee(e.target.value)
                              }
                            }}
                          />
                        </div>
                        <div className="errorMessage">
                          {subjectFormSubmitted && expectedFee == "" && (
                            <p>{t(`Please enter the expected fee`)}</p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 add-btn-wrapper">
                        <button
                          className="btn btn-primary add-btn"
                          onClick={validateCategory}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row sub-exp-wrap">
                    {expSubject?.map((course: any, index: any) => {
                      return (
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <div
                            className="subject-detail-wrapper recreational"
                            key={course.id}
                          >
                            <div className="approval-label">
                              {course.status === 'approved' ? "Approved" : course.status === 'rejected' ? "Rejected" : "Approval Pending"}
                            </div>
                            <div className="rejected-label-icon">
                              {course.status === 'rejected' && <Tooltip title={course?.reason}><InfoOutlinedIcon style={{ fontSize: "16px" }} className="info-icon" /></Tooltip>}
                            </div>
                            <div className="session_slot_count_wrapper">
                              <div className="session_slot_count">
                                <div className="session-count">
                                  {course.experience}
                                </div>
                                <div className="slot-text">Experience</div>
                              </div>
                            </div>
                            <div className="session_date_details_container">
                              <div className="session_subject">
                                {course.activity}
                              </div>
                              <div className="session_subject">
                                {course?.course_mode==="offline"?"On-Premises":course.course_mode}
                              </div>
                              <div className="session_grade">{course.min}</div>
                              {course.isEdit === true && (
                                <div className="session_grade">
                                  <input
                                    value={course.expected_fee}
                                    onChange={(e: any) => {
                                      onEditInput(index, e.target.value);
                                    }}
                                  />
                                  AED{" "}
                                  <DoneIcon
                                    className="edit-icon"
                                    onClick={() => {
                                      onEditSubject(index);
                                    }}
                                  />
                                </div>
                              )}
                              {!course.isEdit && (
                                <div className="session_grade">
                                  {course.expected_fee} AED{" "}
                                  {course.status !== 'approved' && <EditIcon
                                    className="edit-icon"
                                    onClick={() => {
                                      onEditSubject(index);
                                    }}
                                  />}
                                </div>
                              )}
                            </div>
                            {course.status !== 'approved' && <div className="clear-icon-wrapper">
                              <ClearIcon
                                className="clear-icon"
                                onClick={
                                  () => {
                                    handleDeleteSubject(course.id);
                                  } /* handleDeleteSubject(course.id)} */
                                }
                              />
                            </div>}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {location.pathname === ROUTES.PROFILE ?
                    <div className="bi-buttons-wrap">
                      {/* <button
                      className="btn btn-back"
                      onClick={() => onNavigate(1)}
                    >
                      Back
                    </button> */}
                      <button
                        className="btn btn-next"
                        type="submit"
                        onClick={() => {
                          setFormSubmitted(true);
                          formik.handleSubmit();
                        }}
                      >
                        Update
                      </button>
                    </div> :
                    <div className="bi-buttons-wrap">
                      <button
                        className="btn btn-back"
                        onClick={() => onNavigate(1)}
                      >
                        Back
                      </button>
                      <button
                        className="btn btn-next"
                        type="submit"
                        onClick={() => {
                          setFormSubmitted(true);
                          formik.handleSubmit();
                        }}
                      >
                        Next
                      </button>
                    </div>}
                </div>
              );
            }}
          </Formik>
        </Card>

        <CategoryValidationDialog
          open={open}
          onClose={handleClose}
          message={categoryValidationMessage}
          update={putValidationCategory}
        />
      </div>
    </div>
  );
};

export default ReacreationalCamp;
